<template>
	<ul class='pagination'>
		<li :class="'page-item ' + (page==1?'disabled':'')"><a class="btn page-link" @click="changePage(page==1? 0 : 1)">«</a></li>
		<li :class="'page-item ' + (page==1?'disabled':'')"><a class="btn page-link" @click="changePage(page==1? 0 : (page -1))">上一頁</a></li>
		<li v-for="n in pageRenge" :key="n" :class="'page-item ' + (n==page?'active':'') ">
			<a v-if="n >= beginPage" class="btn page-link" @click="changePage(n==page? 0 : n)">{{n}}</a>
		</li>
		<li :class="'page-item ' + (page==total || total==0?'disabled':'')"><a class="btn page-link" @click="changePage(page==total || total==0? 0 :(page +1))">下一頁</a></li>
		<li :class="'page-item ' + (page==total || total==0?'disabled':'')"><a class="btn page-link" @click="changePage(page==total || total==0? 0 :total)">»</a></li>
	</ul>
</template>
<script>
export default {
	delimiters: ['${', '}'],
	props: ['total', 'page'],
	data() {
		return {
			pageRenge: 1,
			beginPage: 1
		}
	},
	methods: {
		reloadPageControl(total, page) {
			if (total != null) {
				if (total > 5) {
					if (total - page <= 3) {
						this.beginPage = total - 4;
					} else {
						this.beginPage = page - 1 > 1 ? page - 2 : 1;
					}
					if (this.beginPage + 4 <= total) {
						this.pageRenge = this.beginPage + 4;
					} else {
						this.pageRenge = total;
					}
				} else {
					this.pageRenge = total;
				}
			}
		},
		changePage(goPage) {
			if (goPage != 0) {
				this.$parent.updateGrid(goPage);
			}
		}
	},
	updated() {
		this.reloadPageControl(this.total, this.page);
	}
}
</script>
<style>
</style>
